import React, { useState, useEffect, useMemo, useRef } from 'react'
import Wrapper from '../../components/Wrapper'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { crmRequest } from '../../store/actions/crm'
import { Paper, Box, Typography, IconButton, Alert, TextField, Grid, Button, Select, MenuItem, FormControl, InputLabel, Checkbox, FormControlLabel, Switch, ListSubheader, Autocomplete, CircularProgress, InputAdornment } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import InfoIcon from '@mui/icons-material/Info'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import RefreshIcon from '@mui/icons-material/Refresh'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import ClearIcon from '@mui/icons-material/Clear'
import { employee, did as dids, weekDays, sip, input, short as shortLabels, lang, crm, shortFunctionList } from '../../translate'
import { toast } from 'react-toastify'
import { greenTheme, inputStyles, selectStyles, inputLabelStyles, sectionTitleStyles, buttonStyles } from '../../helpers/style'
import Api from '../../Api'
import CreateAndEditCrm from '../../components/CreateAndEditCrm'
import Cookies from 'js-cookie'
import { isUrsSession } from '../../helpers/employeePermissions'
const { REACT_APP_SERVER } = process.env;
export default function SipSingle() {
    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const profile = useSelector(state => state.users.ursData)
    const isCreate = id === 'add'
    const isEdit = Boolean(id && id !== 'add' && !isNaN(id))
    const profileEmpty = !profile || Object.keys(profile).length === 0
    const isUrsAdmin = isUrsSession()
        && !!profile?.admingroup
    /** Hide included number / outgoing line when creating with no URS profile; lock included number on edit except for URS admins. */
    const hideIncludedFields = profileEmpty && isCreate
    const disableIncludedNumber = isEdit && !isUrsAdmin
    const crmDataRedux = useSelector(state => state.crm.crmData)
    const langIndex = +localStorage.getItem('atsLang') || 1
    const primaryColor = REACT_APP_SERVER === 'ATS' ? '#0973b9' : greenTheme.primary
    const primaryHover = REACT_APP_SERVER === 'ATS' ? '#075f99' : '#6aa309'
    const primaryDisabled = REACT_APP_SERVER === 'ATS' ? '#6ea8d0' : '#a0c97a'
    const primarySoftBg = REACT_APP_SERVER === 'ATS' ? 'rgba(9, 115, 185, 0.1)' : 'rgba(126, 188, 10, 0.1)'
    const [saving, setSaving] = useState(false)
    const [loading, setLoading] = useState(false)
    const [showPassword, setShowPassword] = useState(true)
    const [recEnabled, setRecEnabled] = useState(true)
    const [isGeneratedBuddy, setIsGeneratedBuddy] = useState(false)
    const [form, setForm] = useState({
        name: '',
        password: '',
        shortNumber: '',
        oldShort: '',
        email: '',
        includedNumber: '',
        oldIncludedNumber: '',
        permissionBlock: '11',
        noAnswerCase: '',
        waitTime: '50',
        rec: 0,
        mob: 1,
        fixed: 2,
        inter: 3,
        payed: 4,
        selectedDays: 2,
        selectedDaysEnd: 1,
        timeStartHour: '00',
        timeStartMinute: '00',
        timeEndHour: '23',
        timeEndMinute: '59',
        buddy: '',
        isSip: 0,
        sipdid: '',
        isWeb: 0,
        webIp: '',
        concurrentCall: 0,
    })
    const [short, setShort] = useState([])
    const [ivr, setIvr] = useState([])
    const [shortFunctionCodes, setShortFunctionCodes] = useState([])
    const [did, setDid] = useState([])
    const [allowedInput, setAllowedInput] = useState({ provider: [], fix_provider: [] })
    const [permission, setPermission] = useState([])
    const [expandedNoAnswerGroups, setExpandedNoAnswerGroups] = useState({ no_answer: true, group: true, ivr: true })
    const [fixShortLoading, setFixShortLoading] = useState(null)
    const [memberGroups, setMemberGroups] = useState([])
    const [selectedForFix, setSelectedForFix] = useState([]) // groupVirtuals selected for fix (checked); the one not selected is the main short
    const [memberCrm, setMemberCrm] = useState([])
    const [newCrm, setNewCrm] = useState({ id: '', buddy: '' })
    const [editCrm, setEditNewCrm] = useState({ id: 0, type: '' })
    const savedSuccessfullyRef = useRef(false)

    const noAnswerOptions = useMemo(() => {
        const empty = { value: '', label: input.select[langIndex], group: '' }
        const apiFc = (shortFunctionCodes.filter((f) => f.code) || []).map((f) => ({ value: f.code, label: f.label, group: 'no_answer' }))
        const fallbackCodes = ['10888', '10777']
        const seen = new Set(apiFc.map((f) => String(f.value)))
        const fallbackFc = fallbackCodes
            .filter((code) => !seen.has(code))
            .map((code) => ({ value: code, label: shortFunctionList?.[code]?.[langIndex] || shortFunctionList?.[code]?.[1] || code, group: 'no_answer' }))
        const fc = [...apiFc, ...fallbackFc].filter((f) => String(f.value) !== '789989')
        const gr = (short || [])
            .filter((item) => String(item.virtual) !== '568898')
            .map((item) => ({ value: String(item.virtual), label: `${item.virtual} (${item.name || ''})`, group: 'group' }))
        const iv = (ivr || [])
            .filter((item) => String(item.virtual) !== '789989' && Number(item.autostatus) !== 25)
            .map((item) => ({ value: String(item.virtual), label: `${item.virtual} (${item.name || ''})`, group: 'ivr' }))
        return [empty, ...fc, ...gr, ...iv]
    }, [shortFunctionCodes, short, ivr, langIndex])

    const sipdidOptions = useMemo(() => {
        const mapDidOpt = (item) => {
            const value = `${item.pref}${item.did}`
            return {
                value,
                label: `${value}${item.notes ? ` (${item.notes})` : ''}`,
                group: 'DID',
            }
        }
        const isMemberDidAllowed = (item) => {
            const number = `${item.pref || ''}${item.did || ''}`
            return Number(item.provider) === 1 && number.length === 11
        }

        if (!isUrsAdmin) {
            const filtered = (did || []).filter(isMemberDidAllowed).map(mapDidOpt)
            const current = String(form.sipdid || '').trim()
            if (current && !filtered.some((o) => o.value === current)) {
                filtered.unshift({ value: current, label: current, group: 'DID' })
            }
            return filtered
        }

        const didOpts = (did || []).map(mapDidOpt)
        const fixProviderList = allowedInput.fix_provider || []
        const providerOpts = [
            ...fixProviderList.map((s) => ({
                value: String(s.number),
                label: `${s.number} ${s.name || ''}`.trim(),
                group: 'SIP provider',
            })),
        ]
        return [...didOpts, ...providerOpts]
    }, [did, allowedInput, isUrsAdmin, form.sipdid])

    const schedulePreview = useMemo(() => {
        const startDay = Number(form.selectedDays) || 1
        const endDay = Number(form.selectedDaysEnd) || 1
        const allDays = [1, 2, 3, 4, 5, 6, 7]
        let activeDays = []
        if (startDay <= endDay) {
            activeDays = allDays.filter((d) => d >= startDay && d <= endDay)
        } else {
            activeDays = allDays.filter((d) => d >= startDay || d <= endDay)
        }

        const startMinutes = (Number(form.timeStartHour) || 0) * 60 + (Number(form.timeStartMinute) || 0)
        const endMinutes = (Number(form.timeEndHour) || 0) * 60 + (Number(form.timeEndMinute) || 0)

        let leftPct = 0
        let widthPct = 100
        if (endMinutes >= startMinutes) {
            leftPct = (startMinutes / 1440) * 100
            widthPct = ((endMinutes - startMinutes) / 1440) * 100
        } else {
            // Cross-midnight range: show full bar to indicate overnight availability.
            leftPct = 0
            widthPct = 100
        }

        return { activeDays, leftPct, widthPct }
    }, [form.selectedDays, form.selectedDaysEnd, form.timeStartHour, form.timeStartMinute, form.timeEndHour, form.timeEndMinute])
    const hourOptions = useMemo(() => Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0')), [])
    const minuteOptions = useMemo(() => Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0')), [])

    useEffect(() => {
        let cancelled = false
        Api.getAllowed()
            .then(({ data }) => {
                if (!cancelled && data?.inputNumber) {
                    setAllowedInput({
                        provider: data.inputNumber.provider || [],
                        fix_provider: data.inputNumber.fix_provider || [],
                    })
                }
            })
            .catch(() => {})
        return () => { cancelled = true }
    }, [])

    const fetchEmployeeData = async (opts = {}) => {
        const { silent = false } = opts
        if (!silent) setLoading(true)
        try {
            const [employeeRes, shortNumbersRes] = await Promise.all([
                Api.employeeGet(id),
                Api.shortGetShortNumbers().catch(() => ({ data: { data: [] } })),
            ])
            const { data } = employeeRes
            setShort(data.short || [])
            setIvr(data.ivr || [])
            setDid(data.did || [])
            setPermission(data.permission || [])
            const fnList = shortNumbersRes?.data?.data || []
            setShortFunctionCodes(fnList.map((l) => ({
                code: String(l.function_code ?? l.code ?? ''),
                label: l[lang[langIndex]] || l[lang[1]] || '',
            })))
            if (data.data) {
                let single = data.data

                const parseDays = (daysString) => {
                    if (!daysString) return { start: '', end: '' }
                    const [start, end] = daysString.split('-').map(Number)
                    return {
                        start: (start && start >= 1 && start <= 7) ? start : '',
                        end: (end && end >= 1 && end <= 7) ? end : ''
                    }
                }

                const parseHours = (hoursString) => {
                    if (!hoursString) return { start: { hour: '', minute: '' }, end: { hour: '', minute: '' } }
                    const [startTime, endTime] = hoursString.split('-')

                    const [startHour = '', startMinute = ''] = (startTime || '').split(':')
                    const [endHour = '', endMinute = ''] = (endTime || '').split(':')
                    return { start: { hour: startHour, minute: startMinute }, end: { hour: endHour, minute: endMinute } }
                }

                const parsedDays = parseDays(single?.group_items_days || '')
                const parsedHours = parseHours(single?.group_items_hours || '')

                const codetypeResult = single.codetypeResult || []
                let parsedMemberGroups = []
                try {
                    const raw = single.member_groups
                    parsedMemberGroups = typeof raw === 'string' ? JSON.parse(raw || '[]') : (raw || [])
                    if (!Array.isArray(parsedMemberGroups)) parsedMemberGroups = []
                } catch (_) {
                    parsedMemberGroups = []
                }
                setMemberGroups(parsedMemberGroups)
                setRecEnabled(single.rec > 0)
                if (single?.buddy) {
                    try {
                        const { data: sipData } = await Api.sipSingle(single.buddy)
                        setMemberCrm(sipData?.single?.crm || [])
                    } catch (_) {
                        setMemberCrm([])
                    }
                } else {
                    setMemberCrm([])
                }
                setForm((prev) => {
                    return {
                        ...prev,

                        name: single.notes || '',
                        password: single.sip_secret || '',
                        shortNumber: parsedMemberGroups[0]?.virtual || single.short || '',
                        oldShort: parsedMemberGroups[0]?.virtual || '',
                        email: single.email || '',
                        includedNumber: single.redirect_output || '',
                        oldIncludedNumber: single.redirect_output || '',
                        permissionBlock: single.oprec != null && single.oprec !== '' ? String(single.oprec) : '11',
                        noAnswerCase: +single.sip_noanswer || '',
                        rec: single.rec || 0,
                        mob: codetypeResult.find(c => c.id === 1) ? 1 : 0,
                        fixed: codetypeResult.find(c => c.id === 2) ? 2 : 0,
                        inter: codetypeResult.find(c => c.id === 3) ? 3 : 0,
                        payed: codetypeResult.find(c => c.id === 4) ? 4 : 0,
                        buddy: single.buddy || '',
                        isSip: single.issip || 0,
                        sipdid: single.sipdid || '',
                        isWeb: single.isweb || 0,
                        webIp: single.sip_uagent || '',
                        ip: single.sip_ip || '',
                        waitTime: parsedMemberGroups[0]?.timeout != null ? String(parsedMemberGroups[0].timeout) : (single.group_timeout || '50'),
                        concurrentCall: parsedMemberGroups[0]?.cwaiting ?? single.allow_concurrent_call ?? single.concurrent_call ?? 0,
                        selectedDays: parsedDays.start || 2,
                        selectedDaysEnd: parsedDays.end || 1,
                        timeStartHour: parsedHours.start.hour || '00',
                        timeStartMinute: parsedHours.start.minute || '00',
                        timeEndHour: parsedHours.end.hour || '23',
                        timeEndMinute: parsedHours.end.minute || '59',

                    }
                })
            }
        } catch (e) {
            if (!silent) toast.error(employee.fetch_error[langIndex])
            console.error(e)
        } finally {
            if (!silent) setLoading(false)
        }
    }

    useEffect(() => {
        fetchEmployeeData()
    }, [id, langIndex])

    useEffect(() => {
        if (id && id !== 'add') {
            dispatch(crmRequest())
        }
    }, [id, dispatch])

    useEffect(() => {
        return () => {
            if (!savedSuccessfullyRef.current && isGeneratedBuddy && form.buddy && id === 'add') {
                Api.deleteBuddy(form.buddy).catch(e => {
                    console.error('Failed to delete buddy on unmount:', e)
                })
            }
        }
    }, [isGeneratedBuddy, form.buddy, id])

    const handleCopyBuddy = async () => {
        if (form.buddy) {
            try {
                await navigator.clipboard.writeText(form.buddy)
                toast.success(employee.copy_success[langIndex])
            } catch (e) {
                toast.error(employee.copy_error[langIndex])
                console.error(e)
            }
        }
    }

    const handleCopyPassword = async () => {
        if (form.password) {
            try {
                await navigator.clipboard.writeText(form.password)
                toast.success(employee.copy_success[langIndex])
            } catch (e) {
                toast.error(employee.copy_error[langIndex])
                console.error(e)
            }
        }
    }

    const handleGeneratePassword = () => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        let password = ''
        for (let i = 0; i < 12; i++) {
            const randomIndex = Math.floor(Math.random() * chars.length)
            password += chars.charAt(randomIndex)
        }
        setForm({ ...form, password })
        setShowPassword(true)
    }
    const handleToggleSip = async (checked) => {
        if (checked) {
            const password = (form.password && String(form.password).trim()) ? form.password : (() => {
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
                let p = ''
                for (let i = 0; i < 12; i++) {
                    p += chars.charAt(Math.floor(Math.random() * chars.length))
                }
                return p
            })()
            if (!isGeneratedBuddy && !form.buddy && id === 'add') {
                const { data: generatedBuddy } = await Api.generateBuddy()
                setForm({
                    ...form,
                    isSip: 1,
                    password: password,
                    buddy: generatedBuddy.buddy
                })
                setShowPassword(true)
            }
            else {
                setForm({
                    ...form,
                    isSip: 1,
                    password: password,
                    buddy: form.buddy
                })
            }
            setIsGeneratedBuddy(true)

        } else {
            const isEdit = id && id !== 'add' && !isNaN(id)
            if (!isEdit && isGeneratedBuddy && form.buddy && id === 'add') {
                try {
                    await Api.deleteBuddy(form.buddy)
                } catch (e) {
                    console.error('Failed to delete buddy:', e)
                }
            }
            setForm({
                ...form,
                isSip: 0,
                ...(isEdit ? {} : { password: '', buddy: '' }),
            })
            if (!isEdit) setIsGeneratedBuddy(false)
        }
    }

    const handleToggleWebRTC = async (checked) => {
        if (checked) {
            const password = (form.password && String(form.password).trim()) ? form.password : (() => {
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
                let p = ''
                for (let i = 0; i < 12; i++) {
                    p += chars.charAt(Math.floor(Math.random() * chars.length))
                }
                return p
            })()
            if (!isGeneratedBuddy && !form.buddy && id === 'add') {
                const { data: generatedBuddy } = await Api.generateBuddy()
                setForm({
                    ...form,
                    isSip: 1,
                    isWeb: 1,
                    password: password,
                    buddy: generatedBuddy.buddy
                })
                setShowPassword(true)
            } else {
                setForm({
                    ...form,
                    isSip: 1,
                    isWeb: 1,
                    password: password,
                    buddy: form.buddy
                })
            }
            setIsGeneratedBuddy(true)
        } else {
            const isEdit = id && id !== 'add' && !isNaN(id)
            if (!isEdit && isGeneratedBuddy && form.buddy && id === 'add') {
                try {
                    await Api.deleteBuddy(form.buddy)
                } catch (e) {
                    console.error('Failed to delete buddy:', e)
                }
            }
            setForm({
                ...form,
                isWeb: 0,
            })
        }
    }
    const handleTogglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    const handleGenerateShortNumber = () => {
        if (short && short.length > 0) {
            const used = new Set(
                short
                    .filter(item => item.isivr === 0 && +item.virtual !== 59999 && +item.virtual !== 568898)
                    .map(item => Number(item.virtual) || 0)
            )
            let newShortNumber = 1
            while (used.has(newShortNumber)) newShortNumber++
            setForm({ ...form, shortNumber: String(newShortNumber) })
        } else {
            setForm({ ...form, shortNumber: '11' })
        }
    }

    const handleFixShort = async (shortId, batch = false) => {
        if (!shortId) return
        if (!batch) setFixShortLoading(shortId)
        try {
            await Api.employeeFixShorts(shortId)
            toast.success(employee.fix_short_success[langIndex])
        } catch (e) {
            console.error(e)
            toast.error(employee.fix_short_error[langIndex])
        } finally {
            if (!batch) setFixShortLoading(null)
        }
    }

    const handleDeleteCrm = async (crmId) => {
        if (!form.buddy) return
        try {
            const { data } = await Api.crmDelete(crmId, form.buddy)
            setMemberCrm(data?.crm || [])
        } catch (e) {
            console.error(e)
        }
    }

    const handleGoBack = async () => {
        if (isGeneratedBuddy && form.buddy && id === 'add') {
            try {
                await Api.deleteBuddy(form.buddy)
            } catch (e) {
                console.error('Failed to delete buddy:', e)
            }
        }
        navigate(-1)
    }

    const handleSave = async () => {
        if (!form.name.trim()) {
            toast.error(employee.name_label[langIndex] + ' ' + input.is_req[langIndex])
            return
        }
        if (!String(form.shortNumber || '').trim()) {
            toast.error(employee.short_number_label[langIndex] + ' ' + input.is_req[langIndex])
            return
        }
        if (!hideIncludedFields && (form.isSip === 0 && form.isWeb === 0) && !String(form.includedNumber || '').trim()) {
            toast.error(employee.included_number_label[langIndex] + ' ' + input.is_req[langIndex])
            return
        }

        if (short.find(s => +s.virtual === +form.shortNumber) && id === 'add') {
            toast.error(input.short_unique[langIndex])
            return
        }

        setSaving(true)
        const isEdit = id && id !== 'add' && !isNaN(id)

        try {

            if (isEdit) {
                await Api.employeeEdit(form)
                toast.success(employee.update_success[langIndex])
                navigate(-1)

            } else {
                await Api.employeeCreate(form)
                savedSuccessfullyRef.current = true
                toast.success(employee.create_success[langIndex])
                navigate(-1)
            }
        } catch (e) {
            if (e.response.status === 400) {
                toast.error(e.response.data.message)
                return
            }
            toast.error(isEdit ? employee.update_error[langIndex] : employee.create_error[langIndex])
            console.error(e)
        } finally {
            setSaving(false)
        }
    }

    if (loading) {
        return (
            <Wrapper>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300, gap: 2 }}>
                    <CircularProgress sx={{ color: primaryColor }} />
                    <Typography variant="body2" color="text.secondary">
                        {langIndex === 2 ? 'Загрузка...' : langIndex === 3 ? 'Բեռնվում է...' : 'Loading...'}
                    </Typography>
                </Box>
            </Wrapper>
        )
    }

    return (
        <Wrapper>
            <div className="tableParent">
                <Paper sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3, borderBottom: '2px solid rgba(0, 0, 0, 0.08)', pb: 2.5, }}>
                        <IconButton
                            size="small"
                            sx={{ color: primaryColor, fontSize: 18 }}
                            onClick={handleGoBack}
                            aria-label="Back"
                        >
                            <ArrowBackIosNewIcon sx={{ fontSize: 20, fontWeight: 700 }} />
                        </IconButton>
                        <Typography variant="h5" sx={{ fontWeight: 700, m: 0 }}>
                            {employee.title[langIndex]}
                        </Typography>
                    </Box>

                    <Alert
                        icon={<InfoIcon />}
                        severity="success"
                        sx={
                            REACT_APP_SERVER !== 'ATS'
                                ? { mb: 3 }
                                : {
                                    mb: 3,
                                    border: `1px solid ${primaryColor}`,
                                    backgroundColor: primarySoftBg,
                                    color: '#1f2937',
                                    '& .MuiAlert-icon': { color: primaryColor },
                                }
                        }
                    >
                        <Typography variant="body2">
                            {employee.info_text[langIndex]}
                        </Typography>
                    </Alert>

                    <Paper
                        sx={{
                            p: 3,
                            border: `1px solid ${primaryColor}`,
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: `${primaryColor} !important` },
                                '&:hover fieldset': { borderColor: `${primaryColor} !important` },
                                '&.Mui-focused fieldset': { borderColor: `${primaryColor} !important` },
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: `${primaryColor} !important`,
                            },
                            '& .MuiInputLabel-root.Mui-focused': { color: primaryColor },
                        }}
                    >
                        <Box sx={{ mb: 3 }}>
                            {localStorage.getItem('access_token_urs') && id && id !== 'add' && !isNaN(id) && memberGroups.length > 1 && (
                                <Box sx={{ mb: 3 }}>
                                    <Typography variant="h6" sx={sectionTitleStyles}>
                                        {employee.set_as_group[langIndex]}
                                    </Typography>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1, justifyItems: 'end' }}>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                                            {memberGroups?.map((item) => {
                                                const groupVirtual = String(item.group_virtual ?? item.virtual ?? '')
                                                const isChecked = selectedForFix.includes(groupVirtual)
                                                const uncheckedCount = memberGroups.filter((g) => !selectedForFix.includes(String(g.group_virtual ?? g.virtual ?? ''))).length
                                                const isOnlyUnchecked = uncheckedCount === 1 && !isChecked
                                                return (
                                                    <FormControlLabel
                                                        key={item.id ?? item.virtual ?? groupVirtual}
                                                        control={
                                                            <Checkbox
                                                                size="small"
                                                                checked={isChecked}
                                                                disabled={fixShortLoading !== null || isOnlyUnchecked}
                                                                onChange={() => {
                                                                    const next = isChecked ? selectedForFix.filter((v) => v !== groupVirtual) : [...selectedForFix, groupVirtual]
                                                                    setSelectedForFix(next)
                                                                    const uncheckedVirtuals = memberGroups
                                                                        .map((g) => String(g.group_virtual ?? g.virtual ?? ''))
                                                                        .filter((v) => !next.includes(v))
                                                                    const mainShort = uncheckedVirtuals[0]
                                                                    if (mainShort != null) setForm((f) => ({ ...f, shortNumber: mainShort }))
                                                                }}
                                                                sx={{
                                                                    color: primaryColor,
                                                                    '&.Mui-checked': { color: primaryColor },
                                                                    padding: 0.25,
                                                                }}
                                                            />
                                                        }
                                                        label={
                                                            <Typography variant="caption" sx={{ fontWeight: 500 }}>
                                                                {item.group_virtual ?? item.virtual}{item.name ? ` (${item.name})` : ''}
                                                            </Typography>
                                                        }
                                                        sx={{
                                                            m: 0,
                                                            py: 0.5,
                                                            px: 1,
                                                            borderRadius: 1,
                                                            border: `1px solid ${primaryColor}`,
                                                        }}
                                                    />
                                                )
                                            })}
                                        </Box>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            disabled={fixShortLoading !== null || selectedForFix.length === 0}
                                            onClick={async () => {
                                                setFixShortLoading(true)
                                                try {
                                                    for (const gv of selectedForFix) {
                                                        const item = memberGroups.find((g) => String(g.group_virtual ?? g.virtual ?? '') === gv)
                                                        if (item) {
                                                            const shortId = item.id ?? item.virtual
                                                            await handleFixShort(shortId, true)
                                                        }
                                                    }
                                                    const mainShortVirtual = memberGroups
                                                        .map((g) => String(g.group_virtual ?? g.virtual ?? ''))
                                                        .find((v) => !selectedForFix.includes(v))
                                                    if (mainShortVirtual != null) {
                                                        setForm((prev) => ({ ...prev, shortNumber: mainShortVirtual }))
                                                    }
                                                    setSelectedForFix([])
                                                    await fetchEmployeeData({ silent: true })
                                                } finally {
                                                    setFixShortLoading(null)
                                                }
                                            }}
                                            sx={{
                                                ...buttonStyles,
                                                fontSize: '0.75rem',
                                                borderColor: primaryColor,
                                                color: '#fff',
                                                '&:hover': { color: primaryColor, borderColor: primaryColor, backgroundColor: primarySoftBg },
                                                '&:disabled': { borderColor: 'rgba(0, 0, 0, 0.26)', border: '1px solid', color: 'rgba(0, 0, 0, 0.26)', background: '#fff' },
                                            }}
                                        >
                                            {fixShortLoading !== null ? employee.save_loading[langIndex] : employee.fix_short_button[langIndex]}
                                        </Button>
                                    </Box>
                                </Box>
                            )}

                            <Typography variant="h6" sx={sectionTitleStyles}>
                                {employee.basic_information[langIndex]}
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label={employee.name_label[langIndex]}
                                        placeholder={employee.name_placeholder[langIndex]}
                                        value={form.name}
                                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                                        variant="outlined"
                                        required
                                        sx={inputStyles}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label={employee.buddy_label[langIndex]}
                                            placeholder={employee.buddy_placeholder[langIndex]}
                                            value={form.buddy}
                                            variant="outlined"
                                            disabled={(form.isSip !== 1 && form.isWeb !== 1) || (id && id !== 'add' && !isNaN(id))}
                                            required={form.isSip === 1 || form.isWeb === 1}
                                            sx={inputStyles}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={handleCopyBuddy}
                                            disabled={(form.isSip !== 1 && form.isWeb !== 1) || !form.buddy}
                                            sx={{
                                                color: primaryColor,
                                                '&:hover': {
                                                    backgroundColor: primarySoftBg,
                                                },
                                                '&:disabled': {
                                                    color: 'rgba(0, 0, 0, 0.26)',
                                                },
                                            }}
                                            aria-label="Copy buddy"
                                        >
                                            <ContentCopyIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={form.isSip === 1}
                                                onChange={(e) => handleToggleSip(e.target.checked)}
                                                disabled={form.isWeb === 1}
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                        color: primaryColor,
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                        backgroundColor: primaryColor,
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-disabled.Mui-checked': {
                                                        color: primaryColor,
                                                        opacity: 0.5,
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-disabled.Mui-checked + .MuiSwitch-track': {
                                                        backgroundColor: primaryColor,
                                                        opacity: 0.5,
                                                    },
                                                }}
                                            />
                                        }
                                        label={employee.is_sip_label[langIndex]}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            type={showPassword ? 'text' : 'password'}
                                            label={employee.password_label[langIndex]}
                                            placeholder={employee.password_placeholder[langIndex]}
                                            value={form.password}
                                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                                            variant="outlined"
                                            disabled={form.isSip !== 1}
                                            required={form.isSip === 1}
                                            sx={inputStyles}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={handleTogglePasswordVisibility}
                                            disabled={form.isSip !== 1}
                                            sx={{
                                                color: primaryColor,
                                                '&:hover': {
                                                    backgroundColor: primarySoftBg,
                                                },
                                                '&:disabled': {
                                                    color: 'rgba(0, 0, 0, 0.26)',
                                                },
                                            }}
                                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                                        >
                                            {showPassword ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={handleCopyPassword}
                                            disabled={(form.isSip !== 1 && form.isWeb !== 1) || !form.password}
                                            sx={{
                                                color: primaryColor,
                                                '&:hover': {
                                                    backgroundColor: primarySoftBg,
                                                },
                                                '&:disabled': {
                                                    color: 'rgba(0, 0, 0, 0.26)',
                                                },
                                            }}
                                            aria-label="Copy password"
                                        >
                                            <ContentCopyIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={handleGeneratePassword}
                                            disabled={form.isSip !== 1 && form.isWeb !== 1}
                                            sx={{
                                                color: primaryColor,
                                                '&:hover': {
                                                    backgroundColor: primarySoftBg,
                                                },
                                                '&:disabled': {
                                                    color: 'rgba(0, 0, 0, 0.26)',
                                                },
                                            }}
                                            aria-label="Generate password"
                                        >
                                            <RefreshIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={form.isWeb === 1}
                                                onChange={(e) => handleToggleWebRTC(e.target.checked)}
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                        color: primaryColor,
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                        backgroundColor: primaryColor,
                                                    },
                                                }}
                                            />
                                        }
                                        label={employee.webrtc_label[langIndex]}
                                    />
                                </Grid>
                                {(form.isWeb === 1 || form.isSip === 1) && (
                                    <Grid item xs={12} sm={6}>
                                        <p className='d-flex flex-column'>
                                            <span style={{color: '#000', fontSize: 14}}>{sip.ip[+localStorage.getItem('atsLang')  || 1 ]}</span>
                                        <span style={{color: '#000', fontSize: 14}}>{form?.ip}</span></p>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label={employee.ip_label[langIndex]}
                                            placeholder={employee.ip_placeholder[langIndex]}
                                            value={form.webIp}
                                            onChange={(e) => setForm({ ...form, webIp: e.target.value })}
                                            variant="outlined"
                                            sx={inputStyles}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Box>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="h6" sx={sectionTitleStyles}>
                                {employee.contact_numbers[langIndex]}
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="email"
                                        label={employee.email_label[langIndex]}
                                        placeholder={employee.email_placeholder[langIndex]}
                                        value={form.email}
                                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                                        variant="outlined"
                                        sx={inputStyles}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label={employee.short_number_label[langIndex]}
                                            placeholder={employee.short_number_placeholder[langIndex]}
                                            value={form.shortNumber}
                                            onChange={(e) => setForm({ ...form, shortNumber: e.target.value })}
                                            variant="outlined"
                                            disabled={isEdit && memberGroups.length > 1 && !isUrsAdmin}
                                            required
                                            sx={inputStyles}
                                        />
                                        <IconButton
                                            size="small"
                                            onClick={handleGenerateShortNumber}
                                            disabled={isEdit && memberGroups.length > 1 && !isUrsAdmin}
                                            sx={{
                                                color: primaryColor,
                                                '&:hover': {
                                                    backgroundColor: primarySoftBg,
                                                },
                                                '&:disabled': {
                                                    color: 'rgba(0, 0, 0, 0.26)',
                                                },
                                            }}
                                            aria-label="Generate short number"
                                        >
                                            <RefreshIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Grid>
                                {!hideIncludedFields && (
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label={employee.included_number_label[langIndex]}
                                        placeholder={employee.included_number_placeholder[langIndex]}
                                        value={form.includedNumber}
                                        onChange={(e) => setForm({ ...form, includedNumber: e.target.value })}
                                        variant="outlined"
                                        required={form.isSip === 0}
                                        disabled={disableIncludedNumber}
                                        sx={inputStyles}
                                        InputProps={{
                                            endAdornment: form.includedNumber ? (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => setForm((prev) => ({ ...prev, oldIncludedNumber: prev.includedNumber, includedNumber: '' }))}
                                                        edge="end"
                                                        disabled={disableIncludedNumber}
                                                        aria-label="clear"
                                                    >
                                                        <ClearIcon fontSize="small" sx={{ color: primaryColor }} />
                                                    </IconButton>
                                                </InputAdornment>
                                            ) : null,
                                        }}
                                    />
                                </Grid>
                                )}
                                {!hideIncludedFields && (
                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        size="small"
                                        options={sipdidOptions}
                                        groupBy={(option) => option.group || ''}
                                        getOptionLabel={(option) => (option && option.label) || ''}
                                        value={sipdidOptions.find((o) => o.value === form.sipdid) ?? null}
                                        onChange={(e, newValue) => setForm({ ...form, sipdid: (newValue && newValue.value) || '' })}
                                        isOptionEqualToValue={(opt, val) => opt && val && opt.value === val.value}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={employee.outgoing_line_label[langIndex]}
                                                placeholder={employee.outgoing_line_placeholder[langIndex]}
                                                sx={inputStyles}
                                                InputLabelProps={{ sx: inputLabelStyles }}
                                            />
                                        )}
                                    />
                                </Grid>
                                )}
                            </Grid>
                        </Box>


                        <Box>
                            <Typography variant="h6" sx={sectionTitleStyles}>
                                {employee.settings[langIndex]}
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel sx={inputLabelStyles}>
                                            {employee.permission_block_label[langIndex]}
                                        </InputLabel>
                                        <Select
                                            size="small"
                                            value={form.permissionBlock}
                                            onChange={(e) => setForm({ ...form, permissionBlock: e.target.value })}
                                            label={employee.permission_block_label[langIndex]}
                                            sx={selectStyles}
                                        >
                                            <MenuItem value="">
                                                <em>{employee.permission_block_placeholder[langIndex]}</em>
                                            </MenuItem>
                                            <MenuItem value="11">{sip.history1[langIndex]}</MenuItem>
                                            <MenuItem value="10">{sip.history[langIndex]}</MenuItem>
                                            <MenuItem value="12">{sip.sipHistory[langIndex]}</MenuItem>
                                            <MenuItem value="13">{sip.sipHistory1[langIndex]}</MenuItem>
                                            {permission && permission.length > 0 && permission.map((item) => (
                                                <MenuItem key={item.id} value={String(item.id)}>
                                                    {langIndex === 3 ? item.name_hy : langIndex === 2 ? item.name_ru : item.name_en}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        size="small"
                                        options={noAnswerOptions}
                                        groupBy={(option) => option.group}
                                        getOptionLabel={(option) => (option && option.label) || ''}
                                        value={noAnswerOptions.find((o) => String(o.value) === String(form.noAnswerCase ?? '')) || null}
                                        onChange={(e, newValue) => setForm({ ...form, noAnswerCase: (newValue && newValue.value != null) ? String(newValue.value) : '' })}
                                        isOptionEqualToValue={(opt, val) => opt && val && String(opt.value) === String(val.value)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={dids.no_answer[langIndex]}
                                                sx={inputStyles}
                                                InputLabelProps={{ sx: inputLabelStyles }}
                                            />
                                        )}
                                        renderGroup={(params) => {
                                            if (params.group === '' || params.group === 'no_answer') {
                                                return <li key={params.key}><ul style={{ padding: 0 }}>{params.children}</ul></li>
                                            }
                                            const groupLabels = { group: shortLabels.group[langIndex], ivr: shortLabels.ivr_lists[langIndex] }
                                            const label = groupLabels[params.group] || params.group
                                            const expanded = expandedNoAnswerGroups[params.group] !== false
                                            return (
                                                <li key={params.key}>
                                                    <ListSubheader
                                                        component="div"
                                                        sx={{
                                                            lineHeight: '40px',
                                                            fontSize: '1rem',
                                                            fontWeight: 600,
                                                            color: '#424242',
                                                            backgroundColor: '#e8e8e8',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 0.5,
                                                            userSelect: 'none',
                                                        }}
                                                        onClick={() => setExpandedNoAnswerGroups((prev) => ({ ...prev, [params.group]: !prev[params.group] }))}
                                                    >
                                                        {expanded ? <ExpandLessIcon sx={{ fontSize: 18, color: '#424242' }} /> : <ExpandMoreIcon sx={{ fontSize: 18, color: '#424242' }} />}
                                                        {label}
                                                    </ListSubheader>
                                                    {expanded && <ul style={{ padding: 0 }}>{params.children}</ul>}
                                                </li>
                                            )
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="number"
                                        label={employee.wait_time_label[langIndex]}
                                        placeholder={employee.wait_time_placeholder[langIndex]}
                                        value={form.waitTime}
                                        onChange={(e) => setForm({ ...form, waitTime: e.target.value })}
                                        variant="outlined"
                                        inputProps={{
                                            min: 0,
                                        }}
                                        sx={inputStyles}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={recEnabled}
                                                    onChange={(e) => {
                                                        setRecEnabled(e.target.checked)
                                                        if (!e.target.checked) {
                                                            setForm({ ...form, rec: 0 })
                                                        }
                                                    }}
                                                    sx={{
                                                        color: primaryColor,
                                                        '&.Mui-checked': {
                                                            color: primaryColor,
                                                        },
                                                    }}
                                                />
                                            }
                                            label={sip.call_rec[langIndex]}
                                        />
                                        <TextField
                                            size="small"
                                            type="number"
                                            label={langIndex === 2 ? 'День' : langIndex === 3 ? 'Օր' : 'Day'}
                                            placeholder={langIndex === 2 ? 'День' : langIndex === 3 ? 'Օր' : 'Day'}
                                            value={form.rec || 0}
                                            onChange={(e) => {
                                                const value = +e.target.value > 1100 ? 1100 : +e.target.value
                                                setForm({ ...form, rec: value })
                                            }}
                                            disabled={!recEnabled}
                                            variant="outlined"
                                            inputProps={{
                                                min: 0,
                                                max: 1100,
                                            }}
                                            sx={{ ...inputStyles, flex: 1 }}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#64748b' }}>
                                        {employee.codelist_label[langIndex]}
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={form.mob === 1}
                                                    onChange={(e) => setForm({ ...form, mob: e.target.checked ? 1 : 0 })}
                                                    sx={{
                                                        color: primaryColor,
                                                        '&.Mui-checked': {
                                                            color: primaryColor,
                                                        },
                                                    }}
                                                />
                                            }
                                            label={sip.mobile[langIndex]}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={form.fixed === 2}
                                                    onChange={(e) => setForm({ ...form, fixed: e.target.checked ? 2 : 0 })}
                                                    sx={{
                                                        color: primaryColor,
                                                        '&.Mui-checked': {
                                                            color: primaryColor,
                                                        },
                                                    }}
                                                />
                                            }
                                            label={sip.fix_num[langIndex]}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={form.inter === 3}
                                                    onChange={(e) => setForm({ ...form, inter: e.target.checked ? 3 : 0 })}
                                                    sx={{
                                                        color: primaryColor,
                                                        '&.Mui-checked': {
                                                            color: primaryColor,
                                                        },
                                                    }}
                                                />
                                            }
                                            label={sip.international[langIndex]}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={form.payed === 4}
                                                    onChange={(e) => setForm({ ...form, payed: e.target.checked ? 4 : 0 })}
                                                    sx={{
                                                        color: primaryColor,
                                                        '&.Mui-checked': {
                                                            color: primaryColor,
                                                        },
                                                    }}
                                                />
                                            }
                                            label={sip.payed[langIndex]}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={{ mt: 4, p: 2, border: '1px solid #e2e8f0', borderRadius: 2, backgroundColor: '#f8fafc' }}>
                            <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600, color: '#334155' }}>
                                {langIndex === 2 ? 'График работы' : langIndex === 3 ? 'Աշխատանքային գրաֆիկ' : 'Working schedule'}
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={3}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel sx={inputLabelStyles}>{langIndex === 2 ? 'С дня' : langIndex === 3 ? 'Օրից' : 'From day'}</InputLabel>
                                        <Select
                                            value={form.selectedDays}
                                            label={langIndex === 2 ? 'С дня' : langIndex === 3 ? 'Օրից' : 'From day'}
                                            onChange={(e) => setForm({ ...form, selectedDays: Number(e.target.value) })}
                                            sx={selectStyles}
                                        >
                                            {weekDays.map((day, dayIndex) => (
                                                <MenuItem key={`from-${dayIndex + 1}`} value={dayIndex + 1}>{day?.[langIndex] || dayIndex + 1}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel sx={inputLabelStyles}>{langIndex === 2 ? 'По день' : langIndex === 3 ? 'Մինչ օր' : 'To day'}</InputLabel>
                                        <Select
                                            value={form.selectedDaysEnd}
                                            label={langIndex === 2 ? 'По день' : langIndex === 3 ? 'Մինչ օր' : 'To day'}
                                            onChange={(e) => setForm({ ...form, selectedDaysEnd: Number(e.target.value) })}
                                            sx={selectStyles}
                                        >
                                            {weekDays.map((day, dayIndex) => (
                                                <MenuItem key={`to-${dayIndex + 1}`} value={dayIndex + 1}>{day?.[langIndex] || dayIndex + 1}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
                                        <Autocomplete
                                            size="small"
                                            options={hourOptions}
                                            value={form.timeStartHour || '00'}
                                            onChange={(e, v) => setForm({ ...form, timeStartHour: v || '00' })}
                                            disableClearable
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={langIndex === 2 ? 'Начало (ч)' : langIndex === 3 ? 'Սկիզբ (ժ)' : 'Start (HH)'}
                                                    sx={inputStyles}
                                                />
                                            )}
                                        />
                                        <Autocomplete
                                            size="small"
                                            options={minuteOptions}
                                            value={form.timeStartMinute || '00'}
                                            onChange={(e, v) => setForm({ ...form, timeStartMinute: v || '00' })}
                                            disableClearable
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={langIndex === 2 ? 'Начало (м)' : langIndex === 3 ? 'Սկիզբ (ր)' : 'Start (MM)'}
                                                    sx={inputStyles}
                                                />
                                            )}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
                                        <Autocomplete
                                            size="small"
                                            options={hourOptions}
                                            value={form.timeEndHour || '23'}
                                            onChange={(e, v) => setForm({ ...form, timeEndHour: v || '23' })}
                                            disableClearable
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={langIndex === 2 ? 'Конец (ч)' : langIndex === 3 ? 'Ավարտ (ժ)' : 'End (HH)'}
                                                    sx={inputStyles}
                                                />
                                            )}
                                        />
                                        <Autocomplete
                                            size="small"
                                            options={minuteOptions}
                                            value={form.timeEndMinute || '59'}
                                            onChange={(e, v) => setForm({ ...form, timeEndMinute: v || '59' })}
                                            disableClearable
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={langIndex === 2 ? 'Конец (м)' : langIndex === 3 ? 'Ավարտ (ր)' : 'End (MM)'}
                                                    sx={inputStyles}
                                                />
                                            )}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>

                            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                {weekDays.map((day, dayIndex) => {
                                    const d = dayIndex + 1
                                    const active = schedulePreview.activeDays.includes(d)
                                    return (
                                        <Box key={`day-line-${d}`} sx={{ display: 'grid', gridTemplateColumns: '48px 1fr', alignItems: 'center', gap: 1 }}>
                                            <Typography variant="caption" sx={{ color: active ? '#0f172a' : '#94a3b8', fontWeight: active ? 700 : 500 }}>
                                                {day?.[langIndex] || d}
                                            </Typography>
                                            <Box sx={{ position: 'relative', height: 10, borderRadius: 999, backgroundColor: '#e2e8f0', overflow: 'hidden' }}>
                                                {active && (
                                                    <Box
                                                        sx={{
                                                            position: 'absolute',
                                                            left: `${schedulePreview.leftPct}%`,
                                                            width: `${Math.max(schedulePreview.widthPct, 2)}%`,
                                                            top: 0,
                                                            bottom: 0,
                                                            backgroundColor: primaryColor,
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </Box>
                                    )
                                })}
                            </Box>
                        </Box>

                        {id && id !== 'add' && !isNaN(id) && form.buddy && (
                            <Box sx={{ mt: 4 }}>
                                <Typography variant="h6" sx={{ ...sectionTitleStyles, mb: 2 }}>
                                    {crm.crm[langIndex]}
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                    {memberCrm?.map((m, idx) => (
                                        <Box
                                            key={idx}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                p: 1.5,
                                                borderRadius: 1,
                                                bgcolor: 'grey.50',
                                                border: '1px solid',
                                                borderColor: 'grey.200',
                                            }}
                                        >
                                            <Typography variant="body2">{m?.crm_list?.name}</Typography>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                {!(Cookies.get('viewer') && +profile?.admingroup === 2) && (
                                                    <>
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            sx={{ minWidth: 60 }}
                                                            onClick={() => {
                                                                setNewCrm((prev) => ({ ...prev, id: m?.crm_list?.id?.toString() || '', buddy: form.buddy }))
                                                                setEditNewCrm({ id: m.id, type: 'view' })
                                                            }}
                                                        >
                                                            View
                                                        </Button>
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            color="primary"
                                                            sx={{ minWidth: 60 }}
                                                            onClick={() => {
                                                                setNewCrm((prev) => ({ ...prev, id: m?.crm_list?.id?.toString() || '', buddy: form.buddy }))
                                                                setEditNewCrm({ id: m.id, type: 'edit' })
                                                            }}
                                                        >
                                                            Edit
                                                        </Button>
                                                    </>
                                                )}
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    color="error"
                                                    sx={{ minWidth: 60 }}
                                                    onClick={() => handleDeleteCrm(m.id)}
                                                >
                                                    Delete
                                                </Button>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                                <FormControl fullWidth sx={{ mt: 2 }}>
                                    <InputLabel id="crm-select-label">{input.select[langIndex]}</InputLabel>
                                    <Select
                                        labelId="crm-select-label"
                                        value={newCrm.id}
                                        label={input.select[langIndex]}
                                        onChange={(e) => {
                                            setNewCrm((prev) => ({ ...prev, id: e.target.value, buddy: form.buddy }))
                                            setEditNewCrm({ id: 0, type: '' })
                                        }}
                                        sx={selectStyles}
                                    >
                                        <MenuItem value="">{input.select[langIndex]}</MenuItem>
                                        {crmDataRedux?.map((c) => (
                                            <MenuItem key={c.id} value={String(c.id)}>
                                                {c.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        )}

                        <Box sx={{ mt: 8, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                variant="contained"
                                color="inherit"
                                onClick={handleSave}
                                disabled={saving}
                                size="small"
                                sx={{
                                    ...buttonStyles,
                                    backgroundColor: `${primaryColor} !important`,
                                    color: '#fff !important',
                                    '&:hover': {
                                        backgroundColor: `${primaryHover} !important`,
                                        color: '#fff !important',
                                    },
                                    '&:focus': { color: '#fff !important' },
                                    '&:disabled': { backgroundColor: `${primaryDisabled} !important`, color: '#fff !important' },
                                }}
                            >
                                {saving ? employee.save_loading[langIndex] : employee.save_button[langIndex]}
                            </Button>
                        </Box>
                    </Paper>
                </Paper>
            </div>
            {newCrm.id && (
                <CreateAndEditCrm
                    setEdit={setEditNewCrm}
                    setCrm={setMemberCrm}
                    edit={editCrm}
                    open={newCrm.id}
                    buddy={newCrm.buddy}
                    setOpen={setNewCrm}
                />
            )}
        </Wrapper>
    )
}
